/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { useAtom } from "jotai";
import styles from "src/features/Event/components/EventPriceSelectorOfFilterModalSheet/eventPriceSelectorOfFilterModalSheet.module.css";
import { eventPriceSelectorActiveIndexAtom } from "../../event.atom";

const EventPriceSelectorOfFilterModalSheet: React.FC = () => {
    const [eventPriceSelectorActiveIndex, setEventPriceSelectorActiveIndex] =
        useAtom(eventPriceSelectorActiveIndexAtom);

    return (
        <div className={styles.container}>
            <div className={styles.item_container}>
                <div
                    className={`${styles.selector_item} ${
                        eventPriceSelectorActiveIndex === 0 ? styles.active : ""
                    }`}
                    onClick={() => {
                        setEventPriceSelectorActiveIndex(0);
                    }}
                >
                    すべて
                </div>
            </div>
            <div className={styles.item_container}>
                <div
                    className={`${styles.selector_item} ${
                        eventPriceSelectorActiveIndex === 1 ? styles.active : ""
                    }`}
                    onClick={() => {
                        setEventPriceSelectorActiveIndex(1);
                    }}
                >
                    無料
                </div>
            </div>
            <div className={styles.item_container}>
                <div
                    className={`${styles.selector_item} ${
                        eventPriceSelectorActiveIndex === 2 ? styles.active : ""
                    }`}
                    onClick={() => {
                        setEventPriceSelectorActiveIndex(2);
                    }}
                >
                    有料
                </div>
            </div>
        </div>
    );
};

export default EventPriceSelectorOfFilterModalSheet;
